import React, { useRef } from "react";
import I18n from "i18n-js";

import useStore from "../../store";
    
const Question = () => {

  const {
    step,
    currentQuestion,
    currentAnswer,
    setAnswer,
    nextStep
  } = useStore(state => state.teamStage);

  const question = currentQuestion();
  const answer = currentAnswer();

  const anwserButtonsRefs = Array(useRef(), useRef(), useRef(), useRef());

  const showAnswers = () => {
    if (step >= 1 && step <= 9) {
      return showButtonsAnswer();
    }
  }

  const showButtonsAnswer = () => {
    const answers = question.answers.map(a => I18n.t(`team_stage.${a}`));
    return (
      <div className="list-of-answers">
        {answers.map((answerText, index) => {
          const score = index + 1;
          const className = answer.score && answer.score === score ? "answer-btn selected" : "answer-btn";

          return (
            <button
              key={index}
              ref={anwserButtonsRefs[index]}
              value={score}
              className={className}
              onClick={(event) => setAnswerOnQuestion(event, step)}
            >
              {answerText}
            </button>
          );
        })}
      </div>
    );
  };

  const setAnswerOnQuestion = (event) => {
    event.preventDefault();

    nextStep();

    anwserButtonsRefs.forEach(ref => ref.current && ref.current.blur());
    
    const score = parseInt(event.target.value);
    setAnswer(question.index - 1, {
      score: score
    });
  };

  return (
    <div className="questions-section">
      <div className="question" data-question-id={question.id}>
        <h6 className="step-counter">
          {`${I18n.t("team_stage.question")} ${question.index} ${I18n.t("team_stage.of_8")}`}
        </h6>
        <p className="question-text">{question.text}</p>
        { showAnswers() }
      </div>
    </div>
  );
}

export default Question;